export const PLATFORM_EMOTES = [
  { key: "clip-it", code: ":clipit:", label: "Clip It", src: "/emotes/clip-it.png" },
  { key: "clutched-up", code: ":clutchedup:", label: "Clutched Up", src: "/emotes/clutched-up.png" },
  { key: "get-active", code: ":getactive:", label: "Get Active", src: "/emotes/get-active.png" },
  { key: "gg", code: ":gg:", label: "GG", src: "/emotes/gg.png" },
  { key: "issa-bot", code: ":issabot:", label: "Issa Bot", src: "/emotes/issa-bot.png" },
  { key: "my-guy", code: ":myguy:", label: "My Guy", src: "/emotes/my-guy.png" },
  { key: "sweaty", code: ":sweaty:", label: "Sweaty", src: "/emotes/sweaty.png" },
  { key: "tuff", code: ":tuff:", label: "Tuff", src: "/emotes/tuff.png" },
  { key: "in-yo-bag", code: ":inyobag:", label: "In Yo Bag", src: "/emotes/in-yo-bag.gif" },
  { key: "oh-lord", code: ":ohlord:", label: "Oh Lord", src: "/emotes/oh-lord.gif" },
  {
    key: "out-of-pocket",
    code: ":outofpocket:",
    label: "Out of Pocket",
    src: "/emotes/out-of-pocket.gif",
  },
];

export const PLATFORM_EMOTE_BY_CODE = new Map(
  PLATFORM_EMOTES.map((emote) => [emote.code, emote])
);

export const PLATFORM_EMOTE_PATTERN =
  /(:clipit:|:clutchedup:|:getactive:|:gg:|:issabot:|:myguy:|:sweaty:|:tuff:|:inyobag:|:ohlord:|:outofpocket:)/g;

